export const endpoint = 'https://strapi.wbcsolucoes.com.br'

export const bearer = 'ae08418fa460797ead4b7f5c18a86611f15df4cb1488265bffab9730f47bd2f0759ced0232114fe1f494346f630e93342abc35eba1f0e8a5a26630fbb5d9fcc92fa775c4d0529facf50943c7e84f6d11463900cde812b3ba721b43a2d02039785c5111d668d5700cc954c6243d215b171e5e1e86fb4711dc1cf14a9c9cce9e6b'

export const version = 'v.2.0.15'